<template>
  <!-- section footer -->
  <footer class="section_footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-6 col-lg-3">
          <h3 class="section_footer_heading">Kontakt</h3>
          <p>
            <i class="icon ion-ios-location-outline"></i>
            Am Pferdemarkt 7, 26603 Aurich
          </p>
          <p><i class="icon ion-ios-telephone-outline"></i> 04941 63344</p>
          <p><i class="icon ion-ios-telephone-outline"></i> 04941 64945</p>
        </div>
        <div class="col-sm-6 col-lg-3">
          <!--
          <h3 class="section_footer_heading">Folge uns</h3>
          <div class="social">
            <ul>
              <li>
                <p><b>Social: </b></p>
              </li>
              <li class="social_icon">
                <a href="https://www.facebook.com/Dafni-Aurich-107236047607178">
                  <i class="icon ion-social-facebook-outline"></i>
                </a>
              </li>
            </ul>
          </div>
          -->
          <!-- .social -->
        </div>
        <div class="col-sm-6 col-lg-3">
          <h3 class="section_footer_heading">Öffnungszeiten</h3>
          <p><b>Mo-So: </b>11:30 - 14:00 Uhr, 17:30 - 23:30 Uhr</p>
          <!-- <p><b>Mo-So: </b>11:30 - 14:00 Uhr, 17:30 - 21:00 Uhr</p> -->
          <!-- <p>Alle Speisen zur Selbstabholung</p> -->
        </div>
        <div class="col-sm-6 col-lg-3">
          <h3 class="section_footer_heading">Rechtliches</h3>
          <p>
            <router-link to="/datenschutz">Datenschutzerklärung</router-link>
          </p>
          <p><router-link to="/impressum">Impressum</router-link></p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <hr />
          <p class="footer_info">
            &#169; 2021 Restaurant Dafni Aurich
          </p>
        </div>
      </div>
      <!-- .row -->
    </div>
    <!-- .container -->
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped></style>
